var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "可约数量设置",
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "before-close": _vm.handleClose,
            width: "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              key: _vm.itemKey,
              class: !_vm.isShow ? "hide-first-row" : "",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.reservationDataNew, "max-height": "500" },
            },
            [
              _c("el-table-column", {
                attrs: { property: "image", label: "图片", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          scope.row.image
                            ? _c("div", { staticClass: "tabPic" }, [
                                _c("img", { attrs: { src: scope.row.image } }),
                              ])
                            : _c("div", [_vm._v("--")]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.specType,
                    expression: "specType",
                  },
                ],
                attrs: { property: "price", label: "产品规格", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "time-height acea-row row-middle mb10",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.attr_arr
                                    ? scope.row.attr_arr[0]
                                    : "默认"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { property: "address", label: "时间段" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.attrValueReservationList,
                        function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass:
                                "time-height acea-row row-middle mb10",
                            },
                            [_vm._v(" " + _vm._s(item.timeSlot) + " ")]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "预约数量" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v("预约数量")]),
                        _c(
                          "el-popover",
                          {
                            attrs: { placement: "top", trigger: "manual" },
                            model: {
                              value: _vm.visible,
                              callback: function ($$v) {
                                _vm.visible = $$v
                              },
                              expression: "visible",
                            },
                          },
                          [
                            _c("div", { staticClass: "title" }, [
                              _vm._v("批量修改"),
                            ]),
                            _c(
                              "div",
                              { staticClass: "flex" },
                              [
                                _c("el-input-number", {
                                  staticClass: "mr10",
                                  staticStyle: { width: "120px" },
                                  attrs: {
                                    min: 0,
                                    max: 99999,
                                    controls: false,
                                    precision: 0,
                                    label: "请输入预约数量",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.batchStockValue,
                                    callback: function ($$v) {
                                      _vm.batchStockValue = $$v
                                    },
                                    expression: "batchStockValue",
                                  },
                                }),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "small" },
                                    on: { click: _vm.close },
                                  },
                                  [_vm._v("取消")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: { click: _vm.batchUpdateStock },
                                  },
                                  [_vm._v("确定")]
                                ),
                              ],
                              1
                            ),
                            _c("span", {
                              staticClass: "el-icon-edit-outline",
                              attrs: { slot: "reference" },
                              on: {
                                click: function ($event) {
                                  _vm.visible = true
                                },
                              },
                              slot: "reference",
                            }),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.attrValueReservationList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "mb10" },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "120px" },
                                attrs: {
                                  min: 0,
                                  max: 99999,
                                  precision: 0,
                                  controls: false,
                                  label: "请输入预约数量",
                                  size: "small",
                                },
                                model: {
                                  value: item.stock,
                                  callback: function ($$v) {
                                    _vm.$set(item, "stock", $$v)
                                  },
                                  expression: "item.stock",
                                },
                              }),
                            ],
                            1
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.submitOk },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }